<template>
	<div class="create" >
		<div class="container">
			<section class="signup-step-container">
				<div class="wizard">
					<div class="wizard-inner">
						<div class="connecting-line"></div>
						<ul class="nav nav-tabs" role="tablist">
							<li role="presentation" id="step_option1" class="active">
								<a href="#step1" data-toggle="tab" aria-controls="step1" role="tab" aria-expanded="true"><span
									class="round-tab">1 </span> <i style="margin: 0px 15px"></i></a>
							</li>
							<li role="presentation" id="step_option2" class="">
								<a href="#step2" data-toggle="tab" aria-controls="step2" role="tab" aria-expanded="false"><span
									class="round-tab">2</span> <i style="margin: 0px 15px"></i></a>
							</li>
							<li role="presentation" id="step_option3" class="">
								<a href="#step3" data-toggle="tab" aria-controls="step3" role="tab"><span class="round-tab">3</span>
									<i style="margin: 0px 15px"></i></a>
							</li>
							<li role="presentation" id="step_option4" class="">
								<a href="#step4" data-toggle="tab" aria-controls="step4" role="tab"><span class="round-tab">4</span>
									<i style="margin: 0px 15px"></i></a>
							</li>
							<!-- <li role="presentation" id="step_option5" class="">
								<a href="#step5" data-toggle="tab" aria-controls="step5" role="tab"><span class="round-tab">5</span>
									<i style="margin: 0px 15px"></i></a>
							</li> -->
						</ul>
					</div>
					<div class="row d-flex justify-content-center">
						<div class="col-8">
							<div class="tab-content" id="main_form">
								<div class="" v-if="step_form1" id="1" role="tabpanel">
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<label>Event Name *</label>
												<input class="form-control" type="text" v-model="data.title" placeholder="Event Name">
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>Start date & time *</label>
												<DatePicker
													v-model="data.start_date"
													placeholder="Select Date"
													style="width: 100%; margin-bottom: 10px;"
													:default-value="new Date()"
													:disabled-date="disabledBeforeToday"
													value-type="format"
													:clearable="false"
												>
												</DatePicker>
												<DatePicker
													style="width: 100%;"
													v-model="data.start_time"
													:disabled-time="disabledTimeForStartTime"
													:time-picker-options="{
											        start: '00:00',
											        step: '00:30',
											        end: '23:30',
											      }"
													format="hh:mm a"
													type="time"
													valueType="format"
													placeholder="hh:mm a"
													:clearable="false"
												>
												</DatePicker>
											</div>
										</div>
										<div class="col-md-6">
											<label>End date & time *</label>
											<DatePicker
												v-model="data.end_date"
												placeholder="Select Date"
												style="width: 100%; margin-bottom: 10px;"
												:default-value="new Date(data.start_date)"
												:disabled-date="disabledBeforeStartDate"
												value-type="format"
												:clearable="false"
											>
											</DatePicker>
											<DatePicker
												style="width: 100%;"
												v-model="data.end_time"
												:default-value="new Date(data.start_date+' '+data.start_time)"
												:disabled-time="disabledTimeBeforeStartTime"
												:time-picker-options="{
											        start: '00:30',
											        step: '00:30',
											        end: '23:30',
											      }"
												format="hh:mm a"
												type="time"
												valueType="format"
												placeholder="hh:mm a"
												:clearable="false"
											>
											</DatePicker>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>Event Type *</label>
												<select name="country" class="form-control" v-if="data.is_private" id="event_type">
													<option value="true" selected="selected">Private</option>
<!--													<option value="true" selected="selected">Public</option>-->
												</select>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>Time Zone *</label>
												<select name="country" class="form-control" id="country">
													<option value="IN" selected="selected">India (UTC+5:30)</option>
												</select>
											</div>
										</div>
										<div class="col-md-12">
											<div class="form-group" v-if="data.image ===''">
												<label>Image *</label>
												<vue-dropzone
													ref="myVueDropzone"
													:options="dropzoneOptions"
													:awss3="awss3"
													v-on:vdropzone-s3-upload-error="s3UploadError"
													v-on:vdropzone-s3-upload-success="s3UploadSuccess"
													id="dropzone"
													v-on:vdropzone-file-added="vfileAdded" style="background: #1B1B1B">
												</vue-dropzone>
											</div>
											<div class="form-group" v-else>
												<div class="mb-3">
													<label>Image *</label>
													<button class="btn btn-outline-danger btn-sm" style="float:right;" @click="data.image = ''">Change Image</button>
												</div>
												<img :src="this.data.image" style="width: 100%; border-radius: 5px; border: 1px dotted" :alt="this.data.title">
											</div>
										</div>
										<div class="col-md-12">
											<div class="form-group">
												<label>Long Description *</label>
												<vue-editor id="long_dec" v-model="data.long_desc" :editorToolbar="customToolbar"></vue-editor>
											</div>
										</div>
										<div class="col-md-12">
											<label>Sponsors (optional)</label>
											<div class="row">
												<div v-for="(s, ind) in data.sponsors" :key="ind" style="border-radius: 5px; border: 1px dotted #ccc; text-align: center; background: #1c1c1c; cursor:pointer; margin: 2px 10px;">
													<img :src="s.sponsor_img" :alt="s.sponsor_name" style="width: 90px; height: 90px;">
													<div @click="removeSponsor(ind)" class="bg-danger" style="bottom: 0; width: 100%;">
														Remove
													</div>
												</div>
												<div data-toggle="modal" data-target="#addSponsor" style="margin: 2px 10px;width: 90px; height: 90px; border-radius: 5px; border: 1px dotted #ccc; text-align: center; background: #1c1c1c; cursor:pointer;">
														<i class="fas fa-plus-circle" style="margin-top: 35%;font-size: 25px;"></i>
												</div>
											</div>
										</div>
									</div>
									<!--									<div class="alert alert-secondary">-->
									<!--										This event will be invite only, please copy the link and share with your targeted audience.-->
									<!--									</div>-->
									<ul class="list-inline text-center mt-5">
										<li>
											<button type="button" @click="steps_submit1()" class="btn btn-primary text-dark"><b>Next</b></button>
										</li>
									</ul>
								</div>
								<div class="" v-if="step_form2" id="2" role="tabpanel">
									<h4 class="text-center">Speakers</h4>
									<hr>
									<div class="row">
										<div class="col-12 mt-2 mb-2">
											<ul class="list-group ">
												<li class="list-group-item bg-white speaker-list" v-for="(s, i) in data.speakers" :key="i">
													{{i + 1}} <b>{{s.name}}</b>
													<span style="float: right; cursor: pointer;"  @click="removeSpeaker(i)">
														<i class="fas fa-times text-danger"></i>
													</span>
													<span style="float: right; cursor: pointer" @click="editSpeaker(s)">
														<i class="fas fa-pen" style="margin-right: 10px;"></i>
													</span>
													<span v-if="s.is_keynote">
														<i class="fas fa-star text-primary" style="margin-left: 10px;"></i>
													</span>
												</li>
											</ul>
										</div>
										<div class="col-12">
											<button  data-toggle="modal" data-target="#addSpeaker"  class="btn btn-outline-light btn-block" style="border: 1px dashed rgb(204, 204, 204) !important;border-radius: 4px;">
												<i class="fas fa-plus"></i> <b>Add Speaker</b>
											</button>
										</div>
									</div>
									<ul class="list-inline text-center mt-5">
										<li>
											<button type="button" @click="step_nav(1)" class="btn btn-primary text-dark mr-1"> <b>Prev</b></button>
											<button type="button" @click="steps_submit2" class="btn btn-primary text-dark"><b>Next</b></button>
										</li>
									</ul>
								</div>
								<div v-if="step_form3"  id="3" role="tabpanel">
									<h4 class="text-center">Agenda</h4>
									<h6 class="text-center">Create all types of sessions for your event. Each Agenda session will be like an auditorium where you can organize multiple parallel sessions.</h6>
									<div class="col-12 mt-2 mb-2" v-if="data.sessions.length > 0">
										<ul class="list-group">
											<li class="list-group-item bg-white" v-for="(s, i) in data.sessions" :key="i">
													{{i + 1}} <b>{{s.session_name}}</b>
													<span style="float: right; cursor: pointer;"  @click="removeSession(i)">
														<i class="fas fa-times text-danger"></i>
													</span>
													<span style="float: right; cursor: pointer" @click="editSession(s, i)">
														<i class="fas fa-pen" style="margin-right: 10px;"></i>
													</span>
											</li>
										</ul>
									</div>
									<div class="col-12 mt-2 mb-2" v-else style="background: #aaa: border:1px dashed black; border-radius:10px; text-align:center;">
										<h5>No Agenda added for this event.</h5>
									</div>
									<div>
										<div
											class="row mb-1" style="padding: 5%">
											<div class="col-md-12">
												<h5>
													<small
														v-if="session_index !== ''"
														class="text-danger float-right" style="font-size: 14px; cursor:pointer;"
														@click="removeSession(session_index)">
														<i class="fa fa-times"></i> Remove
													</small>
												</h5>
											</div>
											<div class="col-md-12">
												<div class="form-group">
													<label>Title *</label>
													<input class="form-control" v-model="session.session_name" type="text" placeholder="Title">
												</div>
											</div>
<!--											<div class="col-md-6">-->
<!--												<label>Start date</label>-->
<!--												<DatePicker-->
<!--													v-model="session.session_date"-->
<!--													placeholder="Select Date"-->
<!--													style="width: 100%; margin-bottom: 10px;"-->
<!--													:default-value="new Date(data.start_date)"-->
<!--													:disabled-date="notStartAndEnd"-->
<!--													value-type="format"-->
<!--													:clearable="false"-->
<!--												>-->
<!--												</DatePicker>-->
<!--											</div>-->
<!--											<div class="col-md-6">-->
<!--												<label>Start time</label>-->
<!--												<DatePicker-->
<!--													style="width: 100%;"-->
<!--													v-model="session.session_time"-->
<!--													:default-value="new Date(data.start_date+' '+data.end_time)"-->
<!--													:disabled-time="disabledTimeBeforeStartTime"-->
<!--													:time-picker-options="{-->
<!--											        start: '00:30',-->
<!--											        step: '00:30',-->
<!--											        end: '23:30',-->
<!--											      }"-->
<!--													format="hh:mm a"-->
<!--													type="time"-->
<!--													valueType="format"-->
<!--													placeholder="hh:mm a"-->
<!--													:clearable="false"-->
<!--												>-->
<!--												</DatePicker>-->
<!--											</div>-->
											<div class="col-md-12">
												<div class="form-group">
													<label>Description *</label>
													<textarea class="form-control"  v-model="session.session_description" type="email" placeholder="Description"></textarea>
												</div>
											</div>
											<div class="col-md-12">
												<div class="form-group">
<!--													<label>Participants</label>-->
													<div style="display: flex; justify-content: space-between">
														<div id="participants-info">
										            <span>
											            <label>Participants *</label>
										              <i class="fas fa-info-circle"></i>
										            </span>
															<div
																class="tooltip-text"
																style="background-color: #101010; border: 1px solid; border-radius: 10px; color: #fff; font-size: 12px;"
															>
																<b>Instruction</b>
																<ul style="text-align: left;">
																	<li>This will be for arranging tables with 4 chairs in each table. Please consider 20% extra participant on your maximum expected participants.</li>
																</ul>
															</div>
														</div>
													</div>
													<input class="form-control" v-model="session.participants" type="number" min="1" max="1000" placeholder="Approximate participants">
												</div>
											</div>
											<div class="col-md-12">
												<div class="form-group">
													<label>Speakers (optional)</label>
<!--													speaker-multiselect-->
													<multiselect v-model="value" @tag="addTag" :searchable="false" :options="data.speakers" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pick some" label="email" track-by="email">
<!--														<template slot="selection"  slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>-->
													</multiselect>
												</div>
											</div>
											<div class="col-md-12">
												<div class="text-center">
													<a href="javascript:void(0)" class="btn btn-outline-primary " @click="addSession">Add</a>
												</div>
											</div>
										</div>
									</div>
									<ul class="list-inline text-center mt-5">
										<li>
											<button type="button" @click="step_nav(2)" class="btn btn-primary text-dark mr-1">
												<b>Prev</b>
											</button>
											<button type="button" @click="steps_submit3()" class="btn btn-primary text-dark"><b>Next</b></button>
										</li>
									</ul>
								</div>
								<!-- <div v-if="step_form4"  id="4" role="tabpanel">
									<div class="text-center">
										Ticket Pricing
										<ul class="list-inline text-center mt-5">
										<li>
											<button type="button" @click="step_nav(3)" class="btn btn-primary text-dark mr-1">
												<b>Prev</b>
											</button>
											<button type="button" @click="steps_submit4()" class="btn btn-primary text-dark"><b>Next</b></button>
										</li>
									</ul>
									</div>
								</div> -->
								<div v-if="step_form4"  id="4" role="tabpanel">
									<div class="text-center">
										<h4>Hurry! 🎉 we have created event for you. </h4>
										<p>Copy the link and you can send the invites to all attendees.</p>
										<div class="form-group">
											<div class="input-group mb-3">
												<input
													type="text"
													class="form-control"
													id="inviteLink"
													placeholder="link"
													:value="inviteLink"
												/>
												<div class="input-group-append">
			                  <span
				                  class="input-group-text btn btn-primary"
				                  id="copy-link"
				                  style="border-radius: 0 5px 5px 0 !important;"
				                  @click="copyLink()"
			                  >Copy</span
			                  >
												</div>
											</div>
										</div>
									</div>
									<ul class="list-inline text-center mt-5">
										<li>
											<button @click="steps_submit4()" class="btn btn-primary text-dark mr-1"><b>Back to dashboard</b></button>
										</li>
										<li>
											<a :href="inviteLink" target="_blank" class="btn btn-primary text-dark"><b>Preview</b></a>
										</li>
									</ul>
								</div>
								<div class="clearfix"></div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
		<!-- Modal -->
		<div class="modal " id="addSponsor" tabindex="-1" role="dialog" aria-labelledby="addSponsor" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Add Sponsor</h5>
						<button type="button" class="close" data-dismiss="modal" id="close-add-sponsor" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group text-left">
							<label>Sponsor Name *</label>
							<input type="text" class="form-control" id="sponsor-name" min="1" max="50" placeholder="Enter sponsor name" v-model="sponsor.sponsor_name" />
						</div>
						<div class="form-group">
							<div v-if="sponsor.sponsor_img === ''">
								<label>Choose Logo *</label>
								<vue-dropzone
									ref="myVueDropzone"
									:options="dropzoneOptionsSponsers"
									:awss3="awss3"
									v-on:vdropzone-s3-upload-error="s3UploadError"
									v-on:vdropzone-s3-upload-success="s3UploadSuccessSponsor"
									id="dropzone-sponser"
									v-on:vdropzone-file-added="vfileAddedSponser" style="background: #1B1B1B">
								</vue-dropzone>
							</div>
							<div v-else>
								<div class="mb-3">
									<label>Choose Logo *</label>
									<button class="btn btn-outline-danger btn-sm" style="float:right;" @click="sponsor.sponsor_img  = ''">Change Image</button>
								</div>
								<div  class="text-center">
									<img :src="sponsor.sponsor_img" :alt="sponsor.sponsor_name" style="width: 100px; height: 100px; border-radius: 5px;">
								</div>
							</div>
						</div>
						<div class="form-group text-left">
							<label>Website Url *</label>
							<input
								type="text"
								class="form-control"
								min="1"
								id="sponsor-sponsor_website"
								placeholder="Website Url"
								v-model="sponsor.sponsor_website"
							/>
						</div>
						<div class="form-group text-left">
							<label>Marketing Message</label>
							<input
								type="text"
								class="form-control"
								min="1"
								id="sponsor-message"
								placeholder="Enter Marketing Message"
								v-model="sponsor.sponsor_message"
							/>
						</div>
						<div class="text-center mt-2">
							<button type="button" class="btn btn-primary" @click="submitSponsor">Add</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal " id="addSpeaker" tabindex="-1" role="dialog" aria-labelledby="addSpeaker" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Add Speaker</h5>
						<button type="button" class="close" data-dismiss="modal" id="close-add-speaker" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group text-left">
							<label>Name *</label>
							<input type="text" class="form-control" id="speaker-name" min="1" max="50" placeholder="Enter speaker name" v-model="speaker.name" />
						</div>
						<div class="form-group text-left">
							<label>Email *</label>
							<input
								type="email"
								class="form-control"
								min="1"
								id="speaker-email"
								required
								placeholder="Enter speaker email"
								v-model="speaker.email"
							/>
						</div>
						<div class="row">
							<div class="col-6">
								<div class="form-group text-left">
									<label>Designation *</label>
									<input
										type="text"
										class="form-control"
										min="1"
										id="speaker-designation"
										placeholder="Enter speaker's designation"
										v-model="speaker.designation"
									/>
								</div>
							</div>
							<div class="col-6">
								<div class="form-group text-left">
									<label>Company *</label>
									<input
										type="text"
										class="form-control"
										min="1"
										id="speaker-company"
										placeholder="Enter speaker's company"
										v-model="speaker.company"
									/>
								</div>
							</div>
						</div>
						<div class="form-group text-left">
							<label>Bio (optional)</label>
							<textarea
								type="text"
								class="form-control"
								id="bio"
								placeholder="Enter speaker's bio"
								v-model="speaker.bio"
							></textarea>
						</div>
						<div class="form-group">
							<div v-if="speaker.photoURL === ''">
								<label>Choose Profile Image *</label>
								<vue-dropzone
									ref="myVueDropzone"
									:options="dropzoneOptionsSpeaker"
									:awss3="awss3"
									v-on:vdropzone-s3-upload-error="s3UploadError"
									v-on:vdropzone-s3-upload-success="s3UploadSuccessSpeaker"
									id="dropzone-speaker"
									v-on:vdropzone-file-added="vfileAddedSpeaker" style="background: #1B1B1B">
								</vue-dropzone>
							</div>
							<div v-else>
								<div class="mb-3">
									<label>Choose Profile Image *</label>
									<button class="btn btn-outline-danger btn-sm" style="float:right;" @click="speaker.photoURL  = ''">Change Image</button>
								</div>
								<div  class="text-center">
									<img :src="speaker.photoURL" :alt="sponsor.sponsor_name" style="width: 100px; height: 100px; border-radius: 5px;">
								</div>
							</div>
						</div>
						<div class="form-check" style="margin-top: -10px; margin-bottom: 10px">
							<input type="checkbox" class="form-check-input" id="org_checkbox" v-model="speaker.is_keynote">
							<label class="form-check-label" for="org_checkbox"> Keynote Speaker.</label>
						</div>
						<div class="text-center mt-2">
							<button type="button" class="btn btn-primary" @click="addSpeakers">Add</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<span style="display: none" data-toggle="modal" data-target="#editSpeaker" id="editSpeakerBtn"></span>
		<div class="modal " id="editSpeaker" tabindex="-1" role="dialog" aria-labelledby="editSpeaker" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Edit Speaker</h5>
						<button type="button" class="close" data-dismiss="modal" id="close-edit-speaker" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group text-left">
							<label>Name *</label>
							<input type="text" required class="form-control" id="edit-speaker-name" min="1" max="50" placeholder="Enter speaker name" v-model="speaker.name" />
						</div>
						<div class="form-group text-left">
							<label>Email *</label>
							<input
								type="email"
								class="form-control"
								min="1"
								id="edit-speaker-email"
								placeholder="Enter speaker email"
								required
								v-model="speaker.email"
							/>
						</div>
						<div class="row">
							<div class="col-6">
								<div class="form-group text-left">
									<label>Designation *</label>
									<input
										type="text"
										class="form-control"
										min="1"
										id="edit-speaker-designation"
										placeholder="Enter speaker's designation"
										v-model="speaker.designation"
									/>
								</div>
							</div>
							<div class="col-6">
								<div class="form-group text-left">
									<label>Company *</label>
									<input
										type="text"
										class="form-control"
										min="1"
										id="edit-speaker-company"
										placeholder="Enter speaker's company"
										v-model="speaker.company"
									/>
								</div>
							</div>
						</div>
						<div class="form-group text-left">
							<label>Bio</label>
							<textarea
								type="text"
								class="form-control"
								id="edit-bio"
								placeholder="Enter speaker's bio"
								v-model="speaker.bio"
							></textarea>
						</div>
						<div class="form-group">
							<div v-if="speaker.photoURL === ''">
								<label>Choose Profile Image *</label>
								<vue-dropzone
									ref="myVueDropzone"
									:options="dropzoneOptionsSpeaker"
									:awss3="awss3"
									v-on:vdropzone-s3-upload-error="s3UploadError"
									v-on:vdropzone-s3-upload-success="s3UploadSuccessSpeaker"
									id="dropzone-speaker"
									v-on:vdropzone-file-added="vfileAddedSpeaker" style="background: #1B1B1B">
								</vue-dropzone>
							</div>
							<div v-else>
								<div class="mb-3">
									<label>Choose Profile Image *</label>
									<button class="btn btn-outline-danger btn-sm" style="float:right;" @click="speaker.photoURL  = ''">Change Image</button>
								</div>
								<div  class="text-center">
									<img :src="speaker.photoURL" :alt="sponsor.sponsor_name" style="width: 100px; height: 100px; border-radius: 5px;">
								</div>
							</div>
						</div>
						<div class="form-check" style="margin-top: -10px; margin-bottom: 10px">
							<input type="checkbox" class="form-check-input" id="edit-keynote" v-model="speaker.is_keynote">
							<label class="form-check-label" for="org_checkbox"> Keynote Speaker.</label>
						</div>
						<div class="text-center mt-2">
							<button type="button" class="btn btn-primary" @click="editSpeakerData()">Save Changes</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import {VueEditor} from "vue2-editor";
  import Multiselect from 'vue-multiselect'

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  export default {
    name: 'create',
    data() {
      return {
        value: [],
        user: JSON.parse(localStorage.getItem('user_info')),
        upcomingEvents: [],
        teams: [],
        customToolbar: [[{'header': [false, 1, 2, 3, 4, 5, 6,]}], ["bold", "italic", "underline"], [{list: "ordered"}, {list: "bullet"}]],
        step_form1: true,
        step_form2: false,
        step_form3: false,
		step_form4: false,
		// step_form5: false,
        showTimePanel: false,
        showTimeRangePanel: false,
	      //Dropzone
        baseUrl: this.$store.state.baseUrl,
        dropzoneOptions: {
          url: "https://httpbin.org/post",
          maxFilesize: 10,
          maxFiles: 1,
          acceptedFiles: "image/*",
          params: {
            success_action_status: 201
          },
          addRemoveLinks: true,
          headers: {'Access-Control-Allow-Origin': '*'},
          dictDefaultMessage: "UPLOAD <i class=\"fas fa-upload\"></i> <br> <small style='font-size:10px;'><i class=\"fas fa-info-circle text-info\"></i> This will give others an idea about the event.</small>"
        },
        dropzoneOptionsSponsers: {
          url: "https://httpbin.org/post",
          maxFilesize: 10,
          maxFiles: 1,
          acceptedFiles: "image/*",
          params: {
            success_action_status: 201
          },
          addRemoveLinks: true,
          headers: {'Access-Control-Allow-Origin': '*'},
          dictDefaultMessage: "UPLOAD <i class=\"fas fa-upload\"></i> <br> <small style='font-size:10px;'><i class=\"fas fa-info-circle text-info\"></i> Logo or any branding image to identify sponsor.</small>"
        },
		dropzoneOptionsSpeaker: {
          url: "https://httpbin.org/post",
          maxFilesize: 10,
          maxFiles: 1,
          acceptedFiles: "image/*",
          params: {
            success_action_status: 201
          },
          addRemoveLinks: true,
          headers: {'Access-Control-Allow-Origin': '*'},
          dictDefaultMessage: "UPLOAD <i class=\"fas fa-upload\"></i> <br> <small style='font-size:10px;'><i class=\"fas fa-info-circle text-info\"></i> Profile Image for speaker.</small>"
        },
        awss3: {
          signingURL: this.baseUrl + "/signature", //Where you will get signed url
          headers: {},
          params: {},
          sendFileToServer: true, //If you want to upload file to your server along with s3
          withCredentials: false
        },
	      //Event Data
        data: {
          title: "",
          image: "",
          long_desc: "",
          networking_enabled: true,
          session_enabled: true,
          noauth_enabled: false,
          is_private: true,
          start_date: "",
          start_time: "",
          end_date: "",
          end_time: "",
          participants: "",
          tags: [],
          sponsors:[],
          speakers: [],
          sessions: [],
        },
        session: {
          session_id: "",
          session_name: "",
          session_description: "",
          // session_date:"",
	        // session_time: "",
          participants:"",
          duration: "35",
          speakers: [],
          sponsors:[],
        },
        sponsor : {
          sponsor_id: "",
          sponsor_name: "",
          sponsor_website:"",
          sponsor_img: "",
	        sponsor_message: "",
        },
        speaker: {
			speaker_id:"",
			name: "",
			email: "",
			designation: "NA",
			company: "NA",
			bio: "",
			is_keynote:false,
			photoURL: "",
			speaker_message: "",
        },
	      session_index: "",
        inviteLink: "",
      }
    },
    components: {
      vueDropzone: vue2Dropzone,
      DatePicker,
      VueEditor,
      Multiselect,
    },
    created() {

    },
	  mounted(){

	  },
    beforeDestroy(){
      // let cnfrm = window.confirm("Do you really want to leave the page ?");
      // if (cnfrm) {
      //   this.$root.$emit("pleaseHandleDeclineByHost", this.uid);
      //   this.handleExit();
      // }
    },
    methods: {
      copyLink() {
        /* Get the text field */
        var copyText = document.getElementById("inviteLink");
        /* Select the text field */
        copyText.select();
        copyText.setSelectionRange(0, 99999); /*For mobile devices*/
        /* Copy the text inside the text field */
        document.execCommand("copy");
        /* Alert the copied text */
        this.$toast.open({
          message: "Link Copied",
          type: "success",
		  position: "top",
		  queue: true
        });
      },
      addTag (newTag) {
        const tag = {
          name: newTag,
          code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
        }
        this.options.push(tag)
        this.value.push(tag)
      },
      removeSponsor(i){
        this.data.sponsors.splice(i, 1)
      },
      submitSponsor(){
        if (this.sponsor.sponsor_img ===''){
          this.$toast.open({
            message: "Please upload sponsor image",
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (this.sponsor.sponsor_name ===''){
          this.$toast.open({
            message: "Please enter sponsor name",
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (this.sponsor.sponsor_website === ''){
          this.$toast.open({
            message: "Please enter sponsor website url",
            type: 'error',
			position: 'top',
			queue: true
          });
        } else {
          let regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
          if (regexp.test(this.sponsor.sponsor_website))
          {
            this.sponsor.sponsor_website = this.getValidUrl(this.sponsor.sponsor_website)
            document.getElementById("close-add-sponsor").click()
            this.sponsor.sponsor_id = this.data.sponsors.length + 1
            this.data.sponsors.push(this.sponsor)
            this.sponsor  = {
              sponsor_id : "",
              sponsor_name: "",
              sponsor_website:"",
			  sponsor_img: "",
			  sponsor_message:""
            }
          }
          else {
            this.$toast.open({
              message: "Please check the website url.",
              type: 'error',
			  position: 'top',
			  queue: true
            });
          }
        }
      },
	    getValidUrl(url = "") {
        let newUrl = window.decodeURIComponent(url);
        newUrl = newUrl.trim().replace(/\s/g, "");
        if(/^(:\/\/)/.test(newUrl)){
          return `http${newUrl}`;
        }
        if(!/^(f|ht)tps?:\/\//i.test(newUrl)){
          return `http://${newUrl}`;
        }
        return newUrl;
      },
      removeSession(i){
        console.log(this.data.sessions)
        this.data.sessions.splice(i, 1)
      },
		editSession(s, i) {
			this.session = s
			this.value = s.speakers
			this.session_index = i
		},
      addSession(){
        if (this.session.session_name ===''){
          this.$toast.open({
            message: "Please upload session name",
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (this.session.session_description ===''){
          this.$toast.open({
            message: "Please enter session description",
            type: 'error',
			position: 'top',
			queue: true
          });
        }else if (this.session.participants === ''){
          this.$toast.open({
            message: "Please enter number of participants",
            type: 'error',
			position: 'top',
			queue: true
          });
        } else {
          if (this.session.participants >= 1  &&  this.session.participants <= 1000) {
            let is_edit = false
            this.data.sessions.forEach(x => {
              if (x.session_id === this.session.session_id) {
				x.speakers = this.value
                x = this.session
                is_edit = true
              }
            })
            if (!is_edit) {
              this.$toast.open({
                message: "New agenda is added",
                type: "success",
				position: "top",
				queue: true
			  });
			  this.session.speakers = this.value
			  this.session.session_id = this.data.sessions.length + 1
			  this.data.sessions.push(this.session)
            } else {
              this.$toast.open({
                message: "Saved",
                type: "success",
				position: "top",
				queue: true
              });
            }
            this.value = []
            this.session  = {
              session_id: "",
              session_name: "",
              session_description: "",
              duration: "35",
              speakers: [],
              participants:"",
            }
          } else {
            this.$toast.open({
              message: "Participants can't be more 1000 in one event.",
              type: "error",
			  position: "top",
			  queue: true
            });
          }
        }
      },
      vfileAdded(file) {
        console.log(file)
        let file_name = file.name
        this.awss3.signingURL = this.baseUrl + "/signature/" + file_name
        this.dropzoneOptions.url = this.baseUrl + "/signature/" + file_name
      },
      vfileAddedSponser(file) {
        console.log(file)
        let file_name = file.name
        this.awss3.signingURL = this.baseUrl + "/signature/" + file_name
        this.dropzoneOptionsSponsers.url = this.baseUrl + "/signature/" + file_name
	  },
	  vfileAddedSpeaker(file) {
        console.log(file)
        let file_name = file.name
        this.awss3.signingURL = this.baseUrl + "/signature/" + file_name
        this.dropzoneOptionsSpeaker.url = this.baseUrl + "/signature/" + file_name
      },
      addSpeakers: function () {
        if (this.speaker.name === "") {
          this.$toast.open({
            message: 'Please enter speaker name',
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (this.speaker.email === "") {
          this.$toast.open({
            message: 'Please enter email',
            type: 'error',
			position: 'top',
			queue: true
          });
        }  else if (this.speaker.designation === "") {
          this.$toast.open({
            message: 'Please enter designation',
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (this.speaker.company === "") {
          this.$toast.open({
            message: 'Please enter company',
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (this.speaker.photoURL === "") {
          this.$toast.open({
            message: 'Please add Speaker Image',
            type: 'error',
			position: 'top',
			queue: true
          });
        } else {
          if (this.ValidateEmail(this.speaker.email)){
            document.getElementById("close-add-speaker").click()
            this.speaker.speaker_id = this.data.speakers.length + 1
            this.data.speakers.push(this.speaker)
            this.speaker = {
              name: "",
              email: "",
              designation: "NA",
              company: "NA",
              photoURL: "",
              bio: "",
              linkedin_link: "",
			  is_keynote: "",
            }
          }else {
            this.$toast.open({
              message: 'Please check entered email.',
              type: 'error',
			  position: 'top',
			  queue: true
            });
          }
        }
      },
	    ValidateEmail(mail) {
			var mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*([.]\w{2,3})+$/;
		    if (mail.match(mailformat)) {
		      return true
		    }
		    return false
		  },
      editSpeakerData: function () {
        if (this.speaker.name === "") {
          this.$toast.open({
            message: 'Please enter speaker name',
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (this.speaker.email === "") {
          this.$toast.open({
            message: 'Please enter email',
            type: 'error',
			position: 'top',
			queue: true
          });
        }  else if (this.speaker.designation === "") {
          this.$toast.open({
            message: 'Please enter designation',
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (this.speaker.company === "") {
          this.$toast.open({
            message: 'Please enter company',
            type: 'error',
			position: 'top',
			queue: true
          });
        } else {
          document.getElementById("close-edit-speaker").click()
          this.data.speakers.forEach(x => {
            if (this.speaker.speaker_id === x.speaker_id) {
              x = this.speaker
            }
          })
          this.speaker = {
            name: "",
            email: "",
            designation: "NA",
            company: "NA",
            photoURL: "",
            bio: "",
            linkedin_link: "",
            is_keynote: "",
          }
        }
      },
      removeSpeaker: function (i) {
        this.data.speakers.splice(i, 1)
      },
      editSpeaker: function(data) {
        this.speaker = data
	      document.getElementById("editSpeakerBtn").click()
      },
      s3UploadError(errorMessage) {
        console.log(errorMessage)
      },
      s3UploadSuccess(s3ObjectLocation) {
        this.data.image = s3ObjectLocation
	  },
	  s3UploadSuccessSpeaker(s3ObjectLocation) {
        this.speaker.photoURL = s3ObjectLocation
      },
      s3UploadSuccessSponsor(s3ObjectLocation) {
        this.sponsor.sponsor_img = s3ObjectLocation
      },
      notBeforeToday(date) {
        return date < today;
      },
      disabledBeforeToday(date) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        return date < today;
	  },
	  disabledTimeForStartTime(time) {
		  // let today = new Date();
		  // today.setHours(0, 0, 0, 0);
		  // let start = "";
      console.log(time);
		  // let start_date = new Date(this.data.start_date)
		  // if(start_date > today) {
      //   return true;
      //   start = new Date().getTime()+1;
		  // } else {
      //   start = new Date().getTime()+1;
		  // }
		//   return time < start;
	  },
	  disabledTimeBeforeStartTime(time){
		if(this.data.start_date === this.data.end_date){
			let start = new Date(this.data.start_date+' '+this.data.start_time).setTime(new Date(this.data.start_date+' '+this.data.start_time).getTime()+1)
			//   console.log(new Date(time).getTime()+ '  '+start);
        	return time < start;
		}
	  },
      disabledBeforeStartDate(date) {
				let start = new Date(this.data.start_date).setDate(new Date(this.data.start_date).getDate() - 1)
        return date < start;
      },
      // notStartAndEnd(date) {
      //   let start = new Date(this.data.start_date).setDate(new Date(this.data.start_date).getDate() - 1)
      //   let end = new Date(this.data.end_date).setDate(new Date(this.data.end_date).getDate())
      //   return date < start && date < end;
      // },
      toggleTimePanel() {
        this.showTimePanel = !this.showTimePanel;
      },
      handleOpenChange() {
        this.showTimePanel = false;
      },
      step_nav: function (id) {
        if (id === 1) {
          document.getElementById('step_option1').classList.add('active')
          document.getElementById('step_option2').classList.remove('active')
          document.getElementById('step_option3').classList.remove('active')
		  document.getElementById('step_option4').classList.remove('active')
		//   document.getElementById('step_option5').classList.remove('active')
          this.step_form1 = true
          this.step_form2 = false
          this.step_form3 = false
		  this.step_form4 = false
        //   this.step_form5 = false
        } else if (id === 2) {
          document.getElementById('step_option1').classList.remove('active')
          document.getElementById('step_option2').classList.add('active')
          document.getElementById('step_option3').classList.remove('active')
          document.getElementById('step_option4').classList.remove('active')
        //   document.getElementById('step_option5').classList.remove('active')
		  this.step_form1 = false
          this.step_form2 = true
          this.step_form3 = false
		  this.step_form4 = false
		//   this.step_form5 = false
        } else if (id === 3) {
          document.getElementById('step_option1').classList.remove('active')
          document.getElementById('step_option2').classList.remove('active')
          document.getElementById('step_option3').classList.add('active')
          document.getElementById('step_option4').classList.remove('active')
        //   document.getElementById('step_option5').classList.remove('active')
		  this.step_form1 = false
          this.step_form2 = false
          this.step_form3 = true
          this.step_form4 = false
		//   this.step_form5 = false
        } else if (id === 4) {
          document.getElementById('step_option1').classList.remove('active')
          document.getElementById('step_option2').classList.remove('active')
          document.getElementById('step_option3').classList.remove('active')
          document.getElementById('step_option4').classList.add('active')
        //   document.getElementById('step_option5').classList.remove('active')
		  this.step_form1 = false
          this.step_form2 = false
          this.step_form3 = false
          this.step_form4 = true
		//   this.step_form5 = false
        } else if(id == 5) {
		  document.getElementById('step_option1').classList.remove('active')
          document.getElementById('step_option2').classList.remove('active')
          document.getElementById('step_option3').classList.remove('active')
          document.getElementById('step_option4').classList.remove('active')
          document.getElementById('step_option5').classList.add('active')
		  this.step_form1 = false
          this.step_form2 = false
          this.step_form3 = false
		  this.step_form4 = false
          this.step_form5 = true
		}
      },
      steps_submit1: function () {
        if (!this.data.title) {
          this.$toast.open({
            message: 'Please enter title',
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (!this.data.image) {
          this.$toast.open({
            message: 'Please upload an image',
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (!this.data.long_desc) {
          this.$toast.open({
            message: 'Please enter long description',
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (!this.data.start_date) {
          this.$toast.open({
            message: 'Please select start date',
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (!this.data.end_date) {
          this.$toast.open({
            message: 'Please select end date',
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (!this.data.start_time) {
          this.$toast.open({
            message: 'Please select start time',
            type: 'error',
			position: 'top',
			queue: true
          });
        } else if (!this.data.end_time) {
          this.$toast.open({
            message: 'Please select end time',
            type: 'error',
			position: 'top',
			queue: true
          });
        } else {
          this.step_nav(2)
        }
        // this.step_nav(2)
      },
      steps_submit2: function () {
        if (this.data.speakers.length > 0) {
          this.step_nav(3)
        } else {
          this.$toast.open({
            message: "Please add atleast one speaker.",
            type: 'error',
			position: 'top',
			queue: true
          });
        }
      },
      steps_submit3: function () {
        if (this.data.sessions.length > 0) {
          this.step_nav(4)
          this.addEventFunction()
        } else {
          this.$toast.open({
            message: "Please add at least one agenda.",
            type: 'error',
			position: 'top',
			queue: true
          });
        }
      },
	    // steps_submit4(){
		// 	this.step_nav(5);
		// 	// this.$router.push('/organization/' + this.$route.params.id)
		// },
		steps_submit4(){
        this.$root.$emit("eventSuccess")

		},
      addEventFunction: function () {
        this.data['org_id'] = this.$route.params.id
        this.$store.dispatch('addEvent', this.data).then(resp => {
          if (resp.data.status === "success") {
            this.$toast.open({
              message: "Event has successfully created.",
              type: 'success',
			  position: 'top',
			  queue: true
            });
            this.inviteLink = location.origin + "/e/" + resp.data.data
          } else {
            this.$toast.open({
              message: resp.data.data,
              type: 'error',
			  position: 'top',
			  queue: true
            });
          }
        })
      }
    }
  }
</script>
<style scoped>
	@import "~vue2-editor/dist/vue2-editor.css";

	/*------------------------*/
	input:focus,
	button:focus,
	.form-control:focus {
		outline: none;
		box-shadow: none;
	}

	.form-control:disabled, .form-control[readonly] {
		background-color: #fff;
	}

	/*----------step-wizard------------*/
	.d-flex {
		display: flex;
	}

	.justify-content-center {
		justify-content: center;
	}

	.align-items-center {
		align-items: center;
	}

	/*---------signup-step-------------*/
	.bg-color {
		background-color: #333;
	}

	.signup-step-container {
		padding: 10px 0px;
		padding-bottom: 60px;
	}

	.wizard .nav-tabs {
		position: relative;
		margin-bottom: 0;
		border-bottom-color: transparent;
	}

	.wizard > div.wizard-inner {
		position: relative;
		margin-bottom: 80px;
		text-align: center;
	}

	.connecting-line {
		height: 2px;
		border-top: 10px dotted #1b1b1b;
		position: absolute;
		width: 75%;
		margin: 0 auto;
		left: 0;
		right: 0;
		top: 15px;
		z-index: 1;
	}

	.wizard .nav-tabs > li.active > a, .wizard .nav-tabs > li.active > a:hover, .wizard .nav-tabs > li.active > a:focus {
		color: #555555;
		cursor: default;
		border: 0;
		border-bottom-color: transparent;
	}

	span.round-tab {
		width: 40px;
		height: 40px;
		line-height: 40px;
		display: inline-block;
		border-radius: 50%;
		background: #1B1B1B;
		z-index: 2;
		position: absolute;
		left: 0;
		text-align: center;
		font-size: 16px;
		color: #fff;
		font-weight: 500;
		border: 1px solid #ddd;
	}

	span.round-tab i {
		color: #555555;
	}

	.wizard li.active span.round-tab {
		background: #FFB229;
		color: #fff;
		border-color: #F57F17;
	}

	.wizard li.active span.round-tab i {
		color: #5bc0de;
	}

	.wizard .nav-tabs > li.active > a i {
		color: #FFB229;
	}

	.wizard .nav-tabs > li {
		width: 25%;
	}

	.wizard li:after {
		content: " ";
		position: absolute;
		left: 46%;
		opacity: 0;
		margin: 0 auto;
		bottom: 0px;
		border: 5px solid transparent;
		border-bottom-color: red;
		transition: 0.1s ease-in-out;
	}


	.wizard .nav-tabs > li a {
		width: 30px;
		height: 30px;
		margin: 20px auto;
		border-radius: 100%;
		padding: 0;
		background-color: transparent;
		position: relative;
		top: 0;
	}

	.wizard .nav-tabs > li a i {
		position: absolute;
		top: -15px;
		font-style: normal;
		font-weight: 400;
		white-space: nowrap;
		left: 50%;
		transform: translate(-50%, -50%);
		font-size: 12px;
		font-weight: 700;
		color: #fff;
	}

	.wizard .nav-tabs > li a:hover {
		background: transparent;
	}

	.wizard .tab-pane {
		position: relative;
		padding-top: 20px;
	}


	.wizard h3 {
		margin-top: 0;
	}

	.prev-step,
	.next-step {
		font-size: 13px;
		padding: 8px 24px;
		border: none;
		border-radius: 4px;
		margin-top: 30px;
	}

	.next-step {
		background-color: #0db02b;
	}

	.skip-btn {
		background-color: #cec12d;
	}

	.step-head {
		font-size: 20px;
		text-align: center;
		font-weight: 500;
		margin-bottom: 20px;
	}

	.term-check {
		font-size: 14px;
		font-weight: 400;
	}

	.custom-file {
		position: relative;
		display: inline-block;
		width: 100%;
		height: 40px;
		margin-bottom: 0;
	}

	.custom-file-input {
		position: relative;
		z-index: 2;
		width: 100%;
		height: 40px;
		margin: 0;
		opacity: 0;
	}

	.custom-file-label {
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		z-index: 1;
		height: 40px;
		padding: .375rem .75rem;
		font-weight: 400;
		line-height: 2;
		color: #495057;
		background-color: #fff;
		border: 1px solid #ced4da;
		border-radius: .25rem;
	}

	.custom-file-label::after {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		z-index: 3;
		display: block;
		height: 38px;
		padding: .375rem .75rem;
		line-height: 2;
		color: #495057;
		content: "Browse";
		background-color: #e9ecef;
		border-left: inherit;
		border-radius: 0 .25rem .25rem 0;
	}

	.footer-link {
		margin-top: 30px;
	}

	.all-info-container {

	}

	.list-content {
		margin-bottom: 10px;
	}

	.list-content a {
		padding: 10px 15px;
		width: 100%;
		display: inline-block;
		background-color: #f5f5f5;
		position: relative;
		color: #565656;
		font-weight: 400;
		border-radius: 4px;
	}

	.list-content a[aria-expanded="true"] i {
		transform: rotate(180deg);
	}

	.list-content a i {
		text-align: right;
		position: absolute;
		top: 15px;
		right: 10px;
		transition: 0.5s;
	}

	.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
		background-color: #fdfdfd;
	}

	.list-box {
		padding: 10px;
	}

	.signup-logo-header .logo_area {
		width: 200px;
	}

	.signup-logo-header .nav > li {
		padding: 0;
	}

	.signup-logo-header .header-flex {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.list-inline li {
		display: inline-block;
	}

	.pull-right {
		float: right;
	}

	/*-----------custom-checkbox-----------*/
	/*----------Custom-Checkbox---------*/
	input[type="checkbox"] {
		position: relative;
		display: inline-block;
		margin-right: 5px;
	}

	input[type="checkbox"]::before,
	input[type="checkbox"]::after {
		position: absolute;
		content: "";
		display: inline-block;
	}

	input[type="checkbox"]::before {
		height: 16px;
		width: 16px;
		border: 1px solid #999;
		left: 0px;
		top: 0px;
		background-color: #fff;
		border-radius: 2px;
	}

	input[type="checkbox"]::after {
		height: 5px;
		width: 9px;
		left: 4px;
		top: 4px;
	}

	input[type="checkbox"]:checked::after {
		content: "";
		border-left: 1px solid #fff;
		border-bottom: 1px solid #fff;
		transform: rotate(-45deg);
	}

	input[type="checkbox"]:checked::before {
		background-color: #18ba60;
		border-color: #18ba60;
	}

	@media (max-width: 767px) {
		.sign-content h3 {
			font-size: 40px;
		}

		.wizard .nav-tabs > li a i {
			display: none;
		}

		.signup-logo-header .navbar-toggle {
			margin: 0;
			margin-top: 8px;
		}

		.signup-logo-header .logo_area {
			margin-top: 0;
		}

		.signup-logo-header .header-flex {
			display: block;
		}
	}
	.vue-dropzone{
		border-radius: 10px;
		background: #000 !important;
		border: 1px solid;
	}
	textarea {
		border-radius: 10px !important;
		background: #000 !important;
		border: 1px solid !important;
	}
	.hide {
		display: none;
	}

	.speaker-list:hover + .hide {
		display: block;
		color: red;
	}
	.multiselect__input {
		background: #fff !important;
	}
	#long_dec { height:100px }
	#participants-info {
		position: relative;
		margin-top: 5px;
		cursor: pointer;
	}

	#participants-info .tooltip-text {
		visibility: hidden;
		width: 370px;
		padding: 10px;
		text-align: center;
		border-radius: 6px;
		position: absolute;
		left: -10px;
		top: -60px;
		z-index: 1;
	}
	.tooltip-text{
		margin-top: -55px;
	}
	#participants-info:hover .tooltip-text {
		visibility: visible;
	}
</style>
